import React, { useEffect } from "react";
import 'common/css/master.css';
import "./routeAreas.css";

const RouteStudents = ({ selectedDrawing, closeDialog }) => {
    useEffect(() => {
        // console.log("RouteStudents component mounted or updated.");
        // console.log("Selected Drawing:", selectedDrawing);
    }, [selectedDrawing]);


    return (
        <div className="dialog-overlay">
            <div className="dialog-box-fixed">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ margin: 0 }}>Students in Drawing: {selectedDrawing.drawingName}</h3>
                    <button
                        onClick={closeDialog}
                        style={{
                            background: "none",
                            border: "none",
                            fontSize: "20px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            color: "#000",
                        }}
                    >
                        &times;
                    </button>
                </div>
                <div className="col-md-12 col-xs-12 col-centered padding-remove">
                    {/* Header Table */}
                    <table className="tableLayout1">
                        <colgroup>
                            <col width="20%" />
                            <col width="80%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th className="text-center">ID</th>
                                <th className="text-center">Student</th>
                            </tr>
                        </thead>
                    </table>
                    {/* Body Table */}
                    <div className="tableDiv" style={{ height: "300px", overflowY: "auto" }}>
                        <table className="tableLayout">
                            <colgroup>
                                <col width="20%" />
                                <col width="80%" />
                            </colgroup>
                            <tbody>
                                {selectedDrawing.lstStudents && selectedDrawing.lstStudents.length > 0 ? (
                                    selectedDrawing.lstStudents.map((student) => (
                                        <tr key={student.studentId}>
                                            <td className="text-center">{student.studentId}</td>
                                            <td className="text-left">{student.name}</td>
                                        </tr>
                                    ))
                                ) : null }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RouteStudents;